import { gql, TypedDocumentNode } from '@apollo/client'

import { Data } from './types'

export const GET_PORTAL_TOKEN: TypedDocumentNode<Data> = gql`
  query getPortalToken {
    portalToken
  }
`
